var ErrorStackParser = require('error-stack-parser');
var SumoMapper = require('./sumo-mapper');
var root = require('./root');

// taken from http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
// given a string 'str' - returns a hash of the string
var generateHashCode = function(str) {
  /* jshint bitwise:false */
  var hash = 0, i, l, character;
  if (!str.length) return hash;
  for (i = 0, l = str.length; i < l; i++) {
    character = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + character;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

var initializeStandardError = function(message, url, line, col, error) {
  error = error || {};
  this.message = message || error.description || error.message;

  // chrome reports filename, mozilla likes fileName
  this.url = url || error.fileName || error.filename || root.window.location.href;
  this.line = line || error.lineNo || error.lineNumber;
  this.col = col || error.colNo || error.columnNumber;
  this.error = error;

  var stack = [];
  try {
    stack = ErrorStackParser.parse(error);
  } catch(e) {
    // we couldn't parse the stack trace from this object
    // which means it wasn't a valid Error instance
    // so, don't rethrow
  }

  this.getStack = function() {
    return stack;
  };

  this.stack = (function() {
    return stack.map(function(sf) {
      return sf.toString();
    }).join('\n');
  })();
};

var initializeSilverlightError = function(error) {
  this.message = error.get_message ? error.get_message() : '';
  this.statusCode = error.get_statusCode ? error.get_statusCode() : '';
  this.exception = error.get_exception ? error.get_exception() : '';
  this.stack = error.get_stackTrace ? error.get_stackTrace() : '';
};


function ErrorModel(message, url, line, col, error) {
  if(message && typeof(message) !== 'string' && arguments.length === 1) {
    // we only got an error object, shift our params around
    error = message;
    message = undefined;
  }

  if(error && error.get_message) {
    // wow, looks like we got a silverlight error...
    // uhmmmm ok, wow, so, ah, let's just use that I guess
    initializeSilverlightError.call(this, error);
  } else {
    initializeStandardError.apply(this, [message, url, line, col, error]);
  }

  this.signature = generateHashCode(this.message + this.stack);

  this.mapper = new SumoMapper({
    'col': 'Column',
    'line': 'LineNumber',
    'url': 'File',
    'stack': 'Stack Trace'
  });

  // set the data into the mapper
  this.mapper.set(this);
}

ErrorModel.prototype.toJSON = function() {
  return {
    message: this.message,
    url: this.url,
    line: this.line,
    col: this.col,
    error: this.error,
    stack: this.getStack(), // return the actual stack frame array
    signature: this.signature
  }
};

ErrorModel.prototype.toLog = function(decorator) {
  if(decorator) {
    this.mapper.set(decorator);
  }
  return this.mapper.toLog();
};

ErrorModel.prototype.toString = function() {
  return this.mapper.toLog();
};

module.exports = ErrorModel;
